/**
 * Authentication Utilities
 * Handles token expiration, logout, and auth error handling
 */

/**
 * Check if token is expired by decoding JWT
 * @param {string} token - JWT token
 * @returns {boolean} - true if expired
 */
export const isTokenExpired = (token) => {
    if (!token) return true;
    
    try {
        // Decode JWT token (simple base64 decode of payload)
        const payload = JSON.parse(atob(token.split('.')[1]));
        const expirationTime = payload.exp * 1000; // Convert to milliseconds
        const currentTime = Date.now();
        
        // Add 5 second buffer to account for clock skew
        return currentTime >= (expirationTime - 5000);
    } catch (error) {
        console.error('Error decoding token:', error);
        return true;
    }
};

/**
 * Get time remaining until token expires
 * @param {string} token - JWT token
 * @returns {number} - milliseconds until expiration
 */
export const getTokenExpirationTime = (token) => {
    if (!token) return 0;
    
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const expirationTime = payload.exp * 1000;
        const currentTime = Date.now();
        return Math.max(0, expirationTime - currentTime);
    } catch (error) {
        console.error('Error decoding token:', error);
        return 0;
    }
};

/**
 * Clear auth data and redirect to login
 * @param {string} message - Optional message to display
 */
export const handleAuthError = (message = 'Your session has expired. Please login again.') => {
    // Clear all auth data
    localStorage.removeItem('mipa_token');
    localStorage.removeItem('mipa_user');
    
    // Show notification
    if (window.showToast) {
        window.showToast(message, 'warning');
    } else {
        console.warn(message);
    }
    
    // Redirect to login page after a short delay
    setTimeout(() => {
        // Use replace to prevent back button issues
        window.location.replace('/login');
    }, 500);
};

/**
 * Check if current page is login page
 * @returns {boolean}
 */
export const isLoginPage = () => {
    return window.location.pathname === '/login' || window.location.pathname === '/';
};
